/**
 * The API returns webinar experts in creation order, while the display order
 * chosen in the admin (drag & drop) is persisted in `numeration`. Without an
 * explicit sort the saved order is lost on every reload, so every place that
 * reads `webinar.experts` has to order them itself.
 */

const toNumeration = (expert) => {
  const value = expert && expert.numeration;
  if (value === null || value === undefined || value === "") return null;

  const parsed = Number(value);
  return isNaN(parsed) ? null : parsed;
};

/**
 * Sorts experts ascending by `numeration`. Experts without a numeration keep
 * their original relative order and are pushed to the end. Non-arrays are
 * returned untouched so callers can pass `webinar.experts` directly.
 *
 * @param {Array} experts
 * @returns {Array} new sorted array (the input is never mutated)
 */
export const sortExpertsByNumeration = (experts) => {
  if (!Array.isArray(experts) || experts.length < 2) return experts;

  return experts
    .map((expert, index) => ({
      expert,
      index,
      numeration: toNumeration(expert),
    }))
    .sort((a, b) => {
      if (a.numeration === null && b.numeration === null)
        return a.index - b.index;
      if (a.numeration === null) return 1;
      if (b.numeration === null) return -1;
      if (a.numeration !== b.numeration) return a.numeration - b.numeration;
      return a.index - b.index;
    })
    .map((item) => item.expert);
};

export default sortExpertsByNumeration;



// WEBPACK FOOTER //
// ./src/utils/sort-experts.js